<template>
  <div id="app" class="clearfix">
    <!-- v-loading="lad1" -->
    <div class="load" v-loading="lad1"></div>
    <headCon />
    <welfare :delay2="delay2" v-if="delay3" @disblock="cli" />
    <bigshot v-if="delay" />
    <!--  -->
    <rankinglist @disnone="cli2" v-if="delay2" />
    <works v-if="delay" />
    <botCode v-if="delay" />
    <!-- 活动规则点击 -->
    <!-- 活动规则点击 -->
    <div class="activityrules">
      <span @click="show1=true">活动规则</span>
    </div>
    <div class="activityrulesCon" v-if="show1">
      <!-- <div ></div> -->
      <transition name="el-zoom-in-top">
        <div v-show="true" class="transition-box activityrulesCon_auto">
          <span class="close" @click="show1=false">
            <img src="./assets/image/gb.png" alt />
          </span>
          <h3>活动规则</h3>
          <div class="fontCon">
            <p>
              1、本次活动从2019年11月1日到2020年2月29日
              <br />2、活动期间，在论坛或摄影人笔记，发布与佳能专微EOS R、 EOS RP、RF镜头相关开箱帖、样片帖，并附200字以上的器材评论。再通过摄影人笔记分享到微信，每个帖子集满30个赞（在论坛中获得的点赞不计入活动）。
              <br />3、开箱帖和样片帖标准
              <br />开箱帖：清晰美观的拍出产品的正面、背面、侧面、及细节（不少于5张照片），最好将相机放置在优美的背景环境中，另外还有自己使用EOS R的工作照，与相机的合影照。并在帖子开头和结尾处加以不少于200字的点评，即视为合格的开箱帖。
              <br />样片帖：上传10张以上带有EXIF信息的照片，并在帖子开头和结尾处，写上您对于佳能专微产品的点评，点评字数不少于200字。
              <br />4、集赞赢好礼
              <br />“集赞赢好礼”的环节，通过手机微信扫描论坛主题帖右上角的二维码，便能将帖子分享到您的微信群或朋友圈，进行集赞行动。只要帖子获得30个以上的赞（在论坛中获得的点赞不计入活动），便可获得由佳友在线提供的价值200元的摄影背心一件（每个参与用户限一件）。
              <br />5、满足上述条件的，在置顶帖中回帖，注明您的报名帖标题和链接，即视为成功的报名参与活动，可以继续参与以下评选活动。
              <br />6、进阶评选——集赞排名奖
              <br />报名成功的参与者，可查看帖子的获赞排名情况。活动结束后，在摄影人笔记中参与的文章获赞数量前10名用户，将会获得佳友在线提供的500元现金奖励。（每人限一个名额）
              <br />7、终极大奖评选
              <br />活动截止后，由佳友在线编辑部进行评选，对集满30个赞并且符合评选标准的帖子进行最终评选。评选出：最佳开箱奖1名、最佳样片奖1名、最佳点评奖1名。每个终极大奖的获胜者，将获得价值万元的佳能专微系列产品。
            </p>

            <!-- <img src="./assets/image/rule_img.jpg" class="botImg" /> -->
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import headCon from "./components/top";
import welfare from "./components/welfare";
import bigshot from "./components/bigshot";
import botCode from "./components/code";
import works from "./components/works";
import rankinglist from "./components/rankinglist";
export default {
  name: "app",
  data() {
    return {
      delay: false,
      delay2: false,
      delay3: true,
      lad1: false,
      lad2: false,
      show1: false
    };
  },
  components: {
    headCon,
    welfare,
    bigshot,
    works,
    botCode,
    rankinglist
  },
  created() {
    setTimeout(() => {
      this.delay = true;
    }, 1500);
  },
  methods: {
    cli() {
      this.lad1 = true;
      setTimeout(() => {
        this.lad1 = false;
        this.delay2 = true;
        this.delay3 = false;
        this.delay = false;
      }, 1000);
    },
    cli2() {
      this.lad1 = true;
      setTimeout(() => {
        this.lad1 = false;
        this.delay2 = false;
        this.delay3 = true;
        this.delay = true;
      }, 1000);
    }
  }
};
</script>

<style>
@import url(./assets/css/index.css);
body {
  position: relative;
}
#app .load .el-loading-mask {
  position: fixed;
}
#app {
  width: 100%;
  background: #fff;
  min-width: 1300px;
  overflow: hidden;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #ededed;
  border-radius: 10px;
}
::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
  border-radius: 10px; /*滚动条的背景区域的圆角*/
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
  background-color: #d9d9d9;
}
.activityrules {
  position: fixed;
  left: 0;
  top: 60%;
  width: 26px;
  padding: 0 10px;
  height: 150px;
  background: #bfa75d;
  z-index: 99;
  font-size: 26px;
  color: #fff;
}
.activityrules span {
  float: left;
  width: 100%;
  margin-top: 23px;
  line-height: 26px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  color: #fff;
}
.activityrulesCon {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}
.activityrulesCon_auto {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -300px 0 0 -650px;
  width: 1300px;
  height: 550px;
  padding-bottom: 50px;
  background: #bfa75d;
}

.close {
  position: absolute;
  right: 25px;
  top: 20px;
  width: 59px;
  /* height: 107px; */
  cursor: pointer;
}
.close img {
  float: left;
  width: 100%;
}
.activityrulesCon_auto h3 {
  float: left;
  margin-top: 65px;
  width: 100%;
  text-align: center;
  font-size: 48px;
  color: #000;
  font-family: siyuan2;
}
.activityrulesCon_auto .fontCon {
  float: left;
  width: 1180px;
  height: 390px;
  padding-right: 40px;
  margin: 50px 0 0 60px;
  overflow-y: auto;
  overflow-x: hidden;
}
.activityrulesCon_auto .fontCon::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #bfa75d;
  border-radius: 10px;
}
.activityrulesCon_auto .fontCon::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
  border-radius: 10px; /*滚动条的背景区域的圆角*/
}
.activityrulesCon_auto .fontCon::-webkit-scrollbar-thumb {
  border-radius: 10px;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
  background-color: #4c443085;
}
.activityrulesCon_auto p {
  float: left;
  font-size: 24px;
  color: #000;
  line-height: 48px;
}
.activityrulesCon_auto .botImg {
  float: left;
  width: 1180px;
  height: 382px;
  margin: 40 60px 0 60px;
  margin-top: 30px;
}
@media screen and (max-width: 1000px) {
  .activityrulesCon_auto {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    width: 1300px;
    height: 57%;
    padding-bottom: 50px;
    background: #bfa75d;
    overflow: hidden;
  }
  .activityrulesCon_auto .fontCon {
    height: auto;
    max-height: 85%;
  }
}
</style>
